import { Box, Button, ButtonGroup, Select } from '@mui/material'
import * as React from 'react'
import { listFromKV } from '../../../Functions/ListItemGenerator'
import { useHealthContext } from '../../../Contexts/Modules/HealthModule/HealthModule'
import { ScreenManageStatusFilter } from './ScreenManage'

function ScreenManageAsyncToolbar({
  facilityID,
  setFacilityID,
  statusFilter,
  setStatusFilter,
}: {
  facilityID: string
  setFacilityID: any
  statusFilter: ScreenManageStatusFilter
  setStatusFilter: any
}) {
  const { facilityQuery } = useHealthContext()
  const facilities = listFromKV(
    facilityQuery.data ?? [],
    facilityQuery.isLoading,
    facilityID || '',
  )
  const statusOn = Object.entries(statusFilter).filter(([, value]) => value)
  return (
    <Box sx={{ display: 'flex', mb: 1, width: 1 }}>
      <Select
        size={'small'}
        inputProps={{ 'aria-label': 'FacilityIDInput' }}
        sx={{ minWidth: 250 }}
        value={facilityID || ''}
        onChange={(event) => setFacilityID(event.target.value)}
      >
        {facilities}
      </Select>
      <ButtonGroup
        sx={{ display: 'flex', ml: 'auto' }}
        size={'small'}
      >
        <Button
          variant={statusFilter.DFT ? 'contained' : undefined}
          disableElevation
          onClick={() =>
            setStatusFilter({
              ...statusFilter,
              DFT: statusOn.length > 1 ? !statusFilter.DFT : true,
            })
          }
        >
          DRAFT
        </Button>
        <Button
          variant={statusFilter.PEN ? 'contained' : undefined}
          disableElevation
          onClick={() =>
            setStatusFilter({
              ...statusFilter,
              PEN: statusOn.length > 1 ? !statusFilter.PEN : true,
            })
          }
        >
          PENDING
        </Button>
        <Button
          variant={statusFilter.INP ? 'contained' : undefined}
          disableElevation
          onClick={() =>
            setStatusFilter({
              ...statusFilter,
              INP: statusOn.length > 1 ? !statusFilter.INP : true,
            })
          }
        >
          IN PROGRESS
        </Button>
        <Button
          variant={statusFilter.CPT ? 'contained' : undefined}
          disableElevation
          onClick={() =>
            setStatusFilter({
              ...statusFilter,
              CPT: statusOn.length > 1 ? !statusFilter.CPT : true,
            })
          }
        >
          COMPLETE
        </Button>
        <Button
          variant={statusFilter.ARC ? 'contained' : undefined}
          disableElevation
          onClick={() =>
            setStatusFilter({
              ...statusFilter,
              ARC: statusOn.length > 1 ? !statusFilter.ARC : true,
            })
          }
        >
          ARCHIVED
        </Button>
      </ButtonGroup>
    </Box>
  )
}

export default ScreenManageAsyncToolbar
